module.exports = __webpack_public_path__ + "img/fyt_p21.ec303b93.png";